/**
 * Contact Schedule Component
 * 
 * Displays the business operating hours in a card format.
 * Shows two separate cards:
 * 1. Weekday hours (Monday to Friday)
 * 2. Saturday hours
 * 
 * Each card includes:
 * - A clock icon
 * - "Horario" (Schedule) title
 * - Days of operation
 * - Specific time ranges
 * 
 * This helps customers know when they can visit or contact the business.
 * 
 * @component
 * @returns {JSX.Element} Business hours schedule cards
 */

import React from 'react';
import './contact-schedule-style.css';

const ContactSchedule = () => {
  return (
    <div className="contact-schedule">
      {/* Weekday schedule card (Monday - Friday) */}
      <div className="contact-schedule__card">
        {/* Card header with clock icon and title */}
        <div className="contact-schedule__header">
          {/* Clock icon SVG */}
          <svg className="contact-schedule__icon" fill="none" viewBox="0 0 16 16">
            <g clipPath="url(#clip0_1_198)">
              <path d="M14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M8 4V8L10.6667 9.33333" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_1_198">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <h3 className="contact-schedule__title">Horario</h3>
        </div>
        {/* Schedule details for weekdays */}
        <div className="contact-schedule__content">
          <p className="contact-schedule__days">Lunes a Viernes:</p>
          <p className="contact-schedule__hours">8:00 a.m. – 12:00 m.d.</p>
          <p className="contact-schedule__hours">1:00 p.m. – 5:00 p.m.</p>
        </div>
      </div>

      {/* Saturday schedule card */}
      <div className="contact-schedule__card">
        {/* Card header with clock icon and title */}
        <div className="contact-schedule__header">
          {/* Clock icon SVG (same as weekday card) */}
          <svg className="contact-schedule__icon" fill="none" viewBox="0 0 16 16">
            <g clipPath="url(#clip0_1_198)">
              <path d="M14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M8 4V8L10.6667 9.33333" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_1_198">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <h3 className="contact-schedule__title">Horario</h3>
        </div>
        {/* Schedule details for Saturday */}
        <div className="contact-schedule__content">
          <p className="contact-schedule__days">Sábados:</p>
          <p className="contact-schedule__hours">8:00 a.m. – 12:00 m.d.</p>
        </div>
      </div>
    </div>
  );
};

export default ContactSchedule;
